import React from 'react';

// Thin stroked X. Distinct from Close, which is a heavier filled grey glyph.
export default function CloseThin() {
  return <svg width="17" height="17" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.25 0.75L0.75 17.25" stroke="#1E2F32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M17.25 17.25L0.75 0.75" stroke="#1E2F32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
}
